import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type RelationshipTypeSelectInput_query$key } from '@/__generated__/RelationshipTypeSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SelectOption,
  type SingleSelectInputProps,
  type SingleSelectInputRef
} from '@/components'

export type RelationshipTypeSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: RelationshipTypeSelectInput_query$key | null | undefined
}

export const RelationshipTypeSelectInput = forwardRef<SingleSelectInputRef, RelationshipTypeSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment RelationshipTypeSelectInput_query on Query {
          relationshipTypes(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.relationshipTypes?.nodes, (relationshipType) => ({
              label: relationshipType!.name,
              value: relationshipType!.rowId
            })),
          [queryData?.relationshipTypes?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

RelationshipTypeSelectInput.displayName = 'RelationshipTypeSelectInput'
